import { get } from '../util/request';
const QUESTIONS_API = '/a/api/getQuestionsAll';

async function fetchQuestions(payload) {
  return get(QUESTIONS_API)(payload).then(response => response.body && response.body.payload);
}

export { fetchQuestions };
